import dotenv from 'dotenv'
dotenv.config()

const awsConfig = {
  clientID: process.env.REACT_APP_OAUTH2_CLIENT_ID, // Cognito User Pool App Client ID
  domainName: process.env.REACT_APP_OAUTH2_DOMAIN_NAME, // Cognito User Pool App Integration Domain Name
  redirectURI: process.env.REACT_APP_OAUTH2_REDIRECT_URI // Redirect URL after logged in/logged out.
}

export default awsConfig
